import React from "react"
import Dialog from "@material-ui/core/Dialog/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent/DialogContent"
import SubjectPicker from "../../../../../../../components/v2/inputs/pickers/subjectPicker"
import GroupMemberPicker from "../../../../../../../components/v2/inputs/pickers/groupMemberPicker"
import { useIdParam } from "../../../../../../../hooks/useIdParam"
import Button from "@material-ui/core/Button"
import DialogActions from "@material-ui/core/DialogActions/DialogActions"

const TeacherScheduleAssignmentFormModal = ({
  open,
  onClose,
  activeSlot,
  schoolSchedule,
}) => {
  const groupId = useIdParam("groupId")
  const [selectedSubject, setSelectedSubject] = React.useState(null)
  const [selectedTeacher, setSelectedTeacher] = React.useState(null)
  const [subjectError, setSubjectError] = React.useState(false)
  const [teacherError, setTeacherError] = React.useState(false)

  const onSubmit = () => {
    console.log({
      block_id: activeSlot.blockId,
      track: activeSlot.trackIdx,
      subject_id: selectedSubject.id,
      user_id: selectedTeacher.id,
    })
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle className={"text-center"}>
        {activeSlot.track ? "Assign" : "Reassign"} Block
      </DialogTitle>
      <DialogContent>
        <div className="form form--modal">
          <SubjectPicker
            value={selectedSubject}
            required
            hasError={subjectError}
            onChange={(e) => setSelectedSubject(e.target.value)}
            calendarId={
              schoolSchedule.has_district_calendar
                ? schoolSchedule?.calendar_id
                : undefined
            }
            scheduleId={
              !schoolSchedule.has_district_calendar
                ? schoolSchedule?.id
                : undefined
            }
          />
          <GroupMemberPicker
            value={selectedTeacher}
            onChange={(e) => setSelectedTeacher(e.target.value)}
            hasError={teacherError}
            required
            // disabled={isPublic}
            groupId={groupId}
            // role={2}
            tags={[2]}
            userLabel={"teacher"}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={onSubmit} color="primary">
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default TeacherScheduleAssignmentFormModal
